<template>
    <div id="app" class="container">
        <div class="loader" v-if="busy">
            <span class="loader__progress">&nbsp;</span>
        </div>
        <div v-else>
            <div class="row">
                <div class="col">
                    <h2>EV Savings</h2>
                    <vehicle-selector></vehicle-selector>
                    <hr/>
                    <current-vehicle></current-vehicle>
                    <hr/>
                    <fuel-prices></fuel-prices>
                    <hr/>
                    <action></action>
                    <result v-if="displayResult"></result>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import VehicleSelector from './components/VehicleSelector'
    import CurrentVehicle from './components/CurrentVehicle'
    import FuelPrices from './components/FuelPrices'
    import Action from './components/Action'
    import Result from './components/Result'
    import {LOAD_DATA} from "./store/action-types";

    export default {
          name: 'app',
          components: {
              VehicleSelector,
              CurrentVehicle,
              FuelPrices,
              Action,
              Result
          },
          computed: {
              busy: function(){
                  return this.$store.state.BUSY;
              },
              displayResult: function(){
                  return (this.$store.state.DISPLAY_RESULT && this.$store.state.SELECTED_VEHICLE.id !== 0);
              }
          },
          created() {
              this.$store.dispatch(LOAD_DATA);
          }
    }
</script>
<style lang="stylus">
    body
        font-size 1.8rem !important

        #app
            position relative
            min-height 400px
            background-color $color-grey
            margin-bottom 2rem
            h2
                margin-top 1.3rem
                margin-bottom 0.8rem
            &:before, :after
                box-sizing border-box
            .loader
                display flex
                position absolute
                z-index 100
                top 0
                left 0
                right 0
                bottom 0
                justify-content center
                align-items center
                background-color $color-white
                transition all .3s
                &:before, :after
                box-sizing border-box

                &__progress
                    width 100px
                    height 100px
                    border 5px solid $color-blue-petrol
                    border-left-color transparent
                    border-radius 50%
                    animation rotate 1.5s linear infinite

                    &:before, :after
                        box-sizing border-box

                @-webkit-keyframes rotate
                    from
                        -webkit-transform rotate(0deg)
                    to
                        -webkit-transform rotate(360deg)
            hr
                margin-top 2 rem
                margin-bottom 2 rem
                background-color $color-grey-border
                width 100%
                height 0
</style>
